import {
    PostDetailsActionType,
    usePostDetailsModalStore,
} from "../../../Components/Modals/PostDetailsModal/PostDetailsModalStore";
import { isRunningInNativeAndriod } from "@infrastructure/Helpers/IsRunningInNativeApp";
import { publish } from "@infrastructure/Events/EventBus";
import { OPEN_PRESENTER } from "../../../Components/Post/PostForm/events";

export const usePostCardClickHandler = (isDashboard = false) => {
    const { setIsPostDetailsModalOpen, setPostDetailsAction } =
        usePostDetailsModalStore();

    const isRunningInAndroid = isRunningInNativeAndriod();

    return (postId: string, action?: PostDetailsActionType) => {
        if (
            isRunningInAndroid &&
            window.WebtipAppBridge &&
            isDashboard &&
            WebtipAppBridge.openFeedPresenter
        ) {
            publish({ name: OPEN_PRESENTER });
            let link = `${process.env.REACT_APP_POST_DETAILS_PAGE}?postId=${postId}`;
            if (action) {
                link += `&action=${action.desiredAction}`;
                if (action.commentId) {
                    link += `&commentId=${action.commentId}`;
                }
            }
            WebtipAppBridge.openFeedPresenter("Community", link, false);
        } else {
            if (action) {
                setPostDetailsAction(action);
            }
            setIsPostDetailsModalOpen(true, parseInt(postId));
        }
    };
};
